import script from "./admin-login.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-login.vue?vue&type=script&setup=true&lang=js"

import "./admin-login.vue?vue&type=style&index=0&id=4e518df1&scoped=true&lang=scss"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e518df1"]])

export default __exports__